import { useTranslation } from 'react-i18next';
import { CustomSelect } from '../../../../components/Shared/CustomSelect';

const Tags = ({ tags, options, formik, isAllDisabled }) => {
    const { t } = useTranslation();
    const handleChange = (value) => {
        const newTags = []
        options.forEach((option) => {
                value.forEach((tag) => {
                    if (tag.value === option.id) {
                        newTags.push(option);
                    }
                });
            });
        formik.setFieldValue(
            'tags',
            newTags
        );
    };

    const tagOptions = options.map((item) => ({ value: item.id, label: item.name.en }));
    const tagsValues = tags.map((item) => ({
        value: item.id,
        label: item.name.en,
    }));


    return (
        <>
            <CustomSelect isDisabled={isAllDisabled} isMulti name="tags" options={tagOptions} className="w-full mt-1" onChange={handleChange} value={tagsValues} isSearchable={false} placeholder={t('Select Tags')} />
        </>
    );
};

export default Tags;
